import request from '@/utils/request'


// 查询用户充值配置列表
export function listRecharge(query) {
  return request({
    url: '/user/recharge/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户充值配置分页
export function pageRecharge(query) {
  return request({
    url: '/user/recharge/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
